module.exports = __webpack_public_path__ + "static/media/tour-red.85b5c3ed.svg";